/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import _ from 'lodash';
import { loadPrograms } from '@/program/api';

const state = {
  programs: [],
  lastPage: 1,
  loadProgramsListState: {
    status: 'idle',
    error: null,
  },
};

const defaultState = {
  programs: [],
  lastPage: 1,
  loadProgramsListState: {
    status: 'idle',
    error: null,
  },
};

const getters = {
};

const mutations = {
  setProgramsListState(state, response) {
    // const programs = response.data;
    // const newPrograms = _.mapKeys(programs, (program) => program.id);
    state.programs = response.data;
    state.lastPage = response.lastPage;
  },
  setLoadProgramsListState(state, message) {
    switch (message.type) {
      case 'loading':
        state.loadProgramsListState.status = 'loading';
        state.loadProgramsListState.error = null;
        break;
      case 'success':
        state.loadProgramsListState.status = 'success';
        break;
      case 'error':
        state.loadProgramsListState.status = 'error';
        state.loadProgramsListState.error = message.payload;
        break;
      default:
        state.loadProgramsListState.status = 'idle';
        state.loadProgramsListState.error = null;
    }
  },
  destroyProgramsList(state) {
    Object.assign(state, _.cloneDeep(defaultState));
  },
};

const actions = {
  async loadProgramsList({ dispatch, commit }, filter) {
    try {
      commit('destroyProgramsList');
      commit('setLoadProgramsListState', { type: 'loading' });
      const response = await loadPrograms(filter);
      await dispatch('setProgramsListState', response.data);
      commit('setLoadProgramsListState', { type: 'success' });
    } catch (error) {
      commit('setLoadProgramsListState', {
        type: 'error',
        payload: error.response,
      });
    }
  },
  setProgramsListState({ commit }, response) {
    commit('setProgramsListState', response);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
